import VulSource from "../../domain/VulSource";
import * as styles from "./SourceTag.module.css";
import {Tag} from "antd";
import React from "react";
import {Link} from "react-router-dom";

function SourceTag(props: { source?: VulSource }) {
    return <>
        <Tag className={styles.source}>
            {props.source?.id
                ? <Link to={`/vul-sources/${props.source.id}`} title={"Go to source"}>{props.source?.name}</Link>
                : props.source?.name
            }
        </Tag>
    </>
}

export default SourceTag;
